/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'

function Checkbox({
  checkedColor, className, isIndeterminate, onChange, label, value, labelColor,
}) {
  return (
    <Lib.Checkbox
      className={className}
      isIndeterminate={isIndeterminate || (value === null || value === undefined)}
      onChange={onChange}
      label={label}
      value={value || isIndeterminate}
      checkedColor={checkedColor}
      labelColor={labelColor}
    />
  )
}

Checkbox.defaultProps = {
  className: '',
  checkedColor: 'primary',
  label: null,
  labelColor: '#000',
  isIndeterminate: false,
  onChange: () => null,
  value: false,
}

Checkbox.propTypes = {
  className: PropType.string,
  checkedColor: PropType.string,
  isIndeterminate: PropType.bool,
  onChange: PropType.func,
  label: PropType.node,
  labelColor: PropType.string,
  value: PropType.bool,
}

export default Checkbox
